import React from "react";

const Footer = () => {
   return <div className="footer">
       Developed By Vishal Singh
   </div>;
};
export  default Footer;
